
document.addEventListener("DOMContentLoaded", function () {

  var sliderConfig = {
    slidesToShow: 4.1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.25,0.46,0.45,0.94)',
      swipeToSlide: true, touchThreshold: 10, waitForAnimate: false,
    swipe: true,
    touchMove: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640,  settings: { slidesToShow: 1.1 } }
    ]
  };

  // ---- DONO SLIDERS PAGE LOAD PE INIT ----
  // Tab 2 visibility:hidden hai (display:none nahi) isliye
  // Slick dono ke liye sahi width measure kar leta hai
  if (jQuery('.finest-slider-tab1').length) {
    jQuery('.finest-slider-tab1').slick(sliderConfig);
  }
  if (jQuery('.finest-slider-tab2').length) {
    jQuery('.finest-slider-tab2').slick(sliderConfig);
  }

  // ---- TAB SWITCH ----
  jQuery('.finest-tab-btn').on('click', function () {
    var targetTab = jQuery(this).data('tab');

    jQuery('.finest-tab-btn').removeClass('active');
    jQuery(this).addClass('active');

    jQuery('.finest-tab-content').removeClass('active');
    jQuery('[data-tab-content="' + targetTab + '"]').addClass('active');

    // Active slider ko reposition karo (layout shift handle karne ke liye)
    var $activeSlider = jQuery('[data-tab-content="' + targetTab + '"] .slick-initialized');
    if ($activeSlider.length) {
      $activeSlider.slick('setPosition');
    }
  });

});
